import './PasswordScoreMeter.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
interface IProps {
  score: number | null;
}

export const PasswordScoreMeter = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  function comment(): ReactElement | null {
    switch (props.score) {
      case null:
        return <span className='password-comment'>{t('none')}</span>;
      case 0:
        return <span className='password-comment very-weak'>{t('very_weak')}</span>;
      case 1:
        return <span className='password-comment weak'>{t('weak')}</span>;
      case 2:
        return <span className='password-comment acceptable'>{t('acceptable')}</span>;
      case 3:
        return <span className='password-comment good'>{t('good')}</span>;
      default:
        return <span className='password-comment very-good'>{t('very_good')}</span>;
    }
  }

  return (
    <div className='password-score-meter-container'>
      <span className={`password-score-meter-item ${props.score !== null ? ' very-weak' : ''}`} />
      <span className={`password-score-meter-item ${props.score && props.score > 0 ? ' weak' : ''}`} />
      <span className={`password-score-meter-item ${props.score && props.score > 1 ? ' acceptable' : ''}`} />
      <span className={`password-score-meter-item ${props.score && props.score > 2 ? ' good' : ''}`} />
      <span className={`password-score-meter-item ${props.score && props.score > 3 ? ' very-good' : ''}`} />
      {comment()}
    </div>
  );
});
